"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
function ToolsLabelsOptionsPanel({ type, className, onToolTypeChange, }) {
    const bridge = (0, bridge_1.useBridge)();
    const [selectedType, setSelectedType] = (0, react_1.useState)(type);
    const selectLeft = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateLabels({ type: bridge_schema_1.ToolType.LabelsLeft });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            currentOptions: { type: bridge_schema_1.ToolType.LabelsLeft },
            type: bridge_schema_1.ToolType.LabelsLeft,
        });
        setSelectedType(bridge_schema_1.ToolType.LabelsLeft);
        onToolTypeChange(bridge_schema_1.ToolType.LabelsLeft);
    };
    const selectRight = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateLabels({ type: bridge_schema_1.ToolType.LabelsRight });
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            currentOptions: { type: bridge_schema_1.ToolType.LabelsRight },
            type: bridge_schema_1.ToolType.LabelsRight,
        });
        setSelectedType(bridge_schema_1.ToolType.LabelsRight);
        onToolTypeChange(bridge_schema_1.ToolType.LabelsRight);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'ToolsLabelsOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(Button, { selected: selectedType === bridge_schema_1.ToolType.LabelsLeft, onClick: selectLeft, "data-e2e": 'ToolsLabelsOptionsPanel_Button', children: (0, jsx_runtime_1.jsx)(IconLeft, { name: ui_1.Icons.Labels_Direction, "data-e2e": 'ToolsLabelsOptionsPanel_IconLeft' }) }), (0, jsx_runtime_1.jsx)(Button, { selected: selectedType === bridge_schema_1.ToolType.LabelsRight, onClick: selectRight, "data-e2e": 'ToolsLabelsOptionsPanel_Button', children: (0, jsx_runtime_1.jsx)(IconRight, { name: ui_1.Icons.Labels_Direction, "data-e2e": 'ToolsLabelsOptionsPanel_IconRight' }) })] }));
}
exports.default = ToolsLabelsOptionsPanel;
const Container = styled_components_1.default.div `
  display: flex;
`;
const Button = (0, styled_components_1.default)(OptionsButton_1.default) `
  margin: 0 20px 0 0;
`;
const IconLeft = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;
`;
const IconRight = (0, styled_components_1.default)(IconLeft) `
  transform: scaleX(-1);
`;
